@if (entry) {
  @if (showPersonendaten(entry.auskunftsperre)) {
    <div class="detail-form">
      @if (entry) {
        <cap-content-header>
          <cap-title>
            <span>{{ "Stammperson" | translate }}: </span>
            @if (entry.version) {
              <span>
                <cap-link
                  [params]="[entry.masterId.id, entry.version.id.id]"
                  [target]="navTargets.NAV_PERSON_STAMM"
                  [tooltipParams]="entry | tooltipPersonstammPipe">
                  <cap-kompakt-stammperson [auskunftsperre]="entry.auskunftsperre" [item]="entry.version"></cap-kompakt-stammperson>
                </cap-link>
              </span>
            }
          </cap-title>
          @if (showEigentum) {
            <cap-title-functionbar>
              <cap-auszug [item]="entry" [withoutFormat]="true"></cap-auszug>
            </cap-title-functionbar>
          }
        </cap-content-header>
      }
      <cap-rubrik [id]="'personalienRubrik'" [isClosable]="false" [isOpen]="true" class="m-0">
        <ng-container title>
          <h2 class="mb-0">{{ "Personalien" | translate }}</h2>
        </ng-container>
        @switch (entry.version.art) {
          @case ("NATUERLICHE_PERSON") {
            <cap-personstamm-natuerliche-person [entry]="entry"></cap-personstamm-natuerliche-person>
          }
          @case ("SCHWEIZERISCHE_JURISTISCHE_PERSON") {
            <cap-personstamm-schweiz-juristische-person [entry]="entry"></cap-personstamm-schweiz-juristische-person>
          }
          @case ("OEFFENTLICHE_KOERPERSCHAFT") {
            <cap-personstamm-oeffentl-rechtl-koerperschaft [entry]="entry"></cap-personstamm-oeffentl-rechtl-koerperschaft>
          }
          @case ("AUSLAENDISCHE_RECHTSFORM") {
            <cap-personstamm-auslaendischerechtsform [entry]="entry"></cap-personstamm-auslaendischerechtsform>
          }
        }
      </cap-rubrik>
      <cap-rubrik [id]="'adressenRubrik'" [isClosable]="true" [isOpen]="entry && entry.adressen">
        <ng-container title>
          <h3 class="mb-0">{{ "AdressenN" | translate }}</h3>
        </ng-container>
        @if (hasAdresssperre(entry.auskunftsperre) && !hasPermissionAdresse) {
          <div>
            <span style="font-style: italic">{{ "stammperson-adresssperre" | translate }}</span>
          </div>
        } @else {
          <cap-personstamm-adressen
            [auskunftsperre]="entry.auskunftsperre"
            [entry]="entry?.version"
            [listLoader]="adressen"></cap-personstamm-adressen>
        }
      </cap-rubrik>
      @if (showEintragungenImGrundbuch) {
        <cap-rubrik [id]="'eintragungenImGrundbuch'" [isClosable]="true" [isOpen]="true">
          <ng-container title>
            <h3 class="mb-0">{{ "EintragungenImGrundbuch" | translate }}</h3>
          </ng-container>
          <ul [(activeId)]="searchMode" [destroyOnHide]="false" #nav="ngbNav" class="nav-tabs" ngbNav>
            <li [ngbNavItem]="'eigentum'">
              <a ngbNavLink>{{ "Eigentum" | translate }}</a>
              <ng-template id="tabEigentumDetail" ngbNavContent>
                @if (showEigentum) {
                  <cap-personstamm-eigentum [personStammMasterId]="personStammMasterId"></cap-personstamm-eigentum>
                } @else {
                  <span>{{"gemaessGrundbuch" | translate}}</span>
                }
              </ng-template>
            </li>
            <li [ngbNavItem]="'uebrigeBerechtigungen'">
              <a ngbNavLink>{{ "UebrigeBerechtigungen" | translate }}</a>
              <ng-template id="tabUebrigeBerechtigungen" ngbNavContent>
                @if (!anzeigeNichtOeffentlicheAnmerkungen) {
                  <p class="hintAnmerkungen">
                    {{ "NurOeffentlicheAnmerkungenWerdenAngezeigt" | translate }}
                  </p>
                }
                @if (showUebrigeBerechtigungen) {
                  <cap-personstamm-uebrige-berechtigungen
                    [personStammMasterId]="personStammMasterId"></cap-personstamm-uebrige-berechtigungen>
                } @else {
                  <span>{{"gemaessGrundbuch" | translate}}</span>
                }
              </ng-template>
            </li>
            <li [ngbNavItem]="'glaeubiger'">
              <a ngbNavLink>{{ "Gläubiger" | translate }}</a>
              <ng-template id="tabGlaeubiger" ngbNavContent>
                @if (showGlaeubigerSchuldner) {
                  <cap-personstamm-glaeubiger
                    [auskunftsperre]="entry.auskunftsperre"
                    [personStammMasterId]="personStammMasterId"></cap-personstamm-glaeubiger>
                } @else {
                  <span>{{"gemaessGrundbuch" | translate}}</span>
                }
              </ng-template>
            </li>
            <li [ngbNavItem]="'schuldner'">
              <a ngbNavLink>{{ "Schuldner" | translate }}</a>
              <ng-template id="tabSchuldner" ngbNavContent>
                @if (showGlaeubigerSchuldner) {
                  <cap-personstamm-schuldner
                    [auskunftsperre]="entry.auskunftsperre"
                    [personStammMasterId]="personStammMasterId"></cap-personstamm-schuldner>
                } @else {
                  <span>{{"gemaessGrundbuch" | translate}}</span>
                }
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </cap-rubrik>
      }
    </div>
  } @else {
    <div>
      <span style="font-style: italic">{{ "stammperson-auskunftsperre" | translate }}</span>
    </div>
  }
} @else {
  <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
}

<ng-template #keine><span>{{"Keine" | translate}}</span></ng-template>
